module.exports = __webpack_public_path__ + "23a73ec3d5c507c6157164a9c0954773.svg";